import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selectButton", "footer", "label", "targetInput"]
  static values = { sourceLabel: String, sourceDate: String }

  select(event) {
    const button = event.currentTarget

    if (button.classList.contains("button--selected")) {
      this.selectButtonTargets.forEach((btn) => {
        btn.textContent = "Select"
        btn.classList.remove("button--selected")
      })
      this.targetInputTarget.value = ""
      this.labelTarget.textContent = ""
      this.footerTarget.classList.remove("transfer-footer--visible", "transfer-footer--warning")
      return
    }

    this.selectButtonTargets.forEach(btn => {
      btn.textContent = "Select"
      btn.classList.remove("button--selected")
    })

    button.textContent = "Selected"
    button.classList.add("button--selected")

    this.targetInputTarget.value = button.dataset.movementId
    this.labelTarget.textContent = `${this.sourceLabelValue} → ${button.dataset.movementLabel}`
    this.footerTarget.classList.add("transfer-footer--visible")

    const datesMatch = button.dataset.movementDate === this.sourceDateValue
    this.footerTarget.classList.toggle("transfer-footer--warning", !datesMatch)
  }
}
